import { TitleValue } from "#core/components/text/TitleValue"
import { CardMedia } from "@mui/material"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import Grid2 from "@mui/material/Unstable_Grid2"

export function MyTeamColaborador({ colaborador, onClick }) {
	const { no_empleado } = colaborador

	const fields = {
		"No. Empleado": no_empleado,
		Nombre: colaborador.full_name,
		Sucursal: colaborador?.sucursal_name,
		Departamento: colaborador?.departamento_name,
		"Perfil Puesto": colaborador?.perfil_puesto_name,
	}

	let fields_view = []
	for (const property in fields) {
		fields_view.push(
			<Grid2 xs={2.3} key={property}>
				<TitleValue
					label={property}
					key={property}
					value={fields[property]}
					color="text.secondary"
					noWrap
				/>
			</Grid2>,
		)
	}

	return (
		<Card
			onClick={onClick}
			sx={{
				minWidth: { xs: "95vw" },
				// width: "100%",
				height: "100%",
				display: "flex",
				cursor: onClick ? "pointer" : "default",
				"&:hover": {
					boxShadow: onClick ? 6 : "none",
				},
			}}
		>
			<CardMedia
				component="img"
				sx={{ width: 100 }}
				image={colaborador?.photo}
				alt="Colaborador"
				onError={(e) => {
					e.target.onerror = null
					e.target.src =
						"https://imagenespublicas.s3.us-east-2.amazonaws.com/usuario.webp"
				}}
			/>
			<CardContent
				sx={{
					flex: "1 0 auto",
					alignContent: "center",
					alignItems: "center",
					display: "flex",
					flexDirection: "column",
					gap: 2,
				}}
			>
				{/* <TextTitleMain
					gutterBottom
					variant="h6"
					component="div"
					color="text.secondary"
					label={colaborador.full_name}
				/> */}
				<Grid2 container spacing={2} width={"100%"}>
					{fields_view}
				</Grid2>
			</CardContent>
		</Card>
	)
}
